import * as UserApi from '../api/UserRequest'
import * as ItemApi from '../api/ItemManipulation'
import * as LogsApi from '../api/LogsRequest'
import * as FormApi from '../api/formRequest'

export const loadModal = (data, logDetails) => async(dispatch) => {
    dispatch({type: "MODAL_ITEM_VIEW_START"});
    try {
        await LogsApi.sendLog(JSON.stringify(logDetails));
        dispatch({type: "MODAL_ITEM_VIEW_SUCCESS", data: {
            modalType: data.modalType,
            ...data
        }})
        // dispatch({type: "MODAL_LOAD", modalPackage: data})
    } catch (error) {
        dispatch({type: "MODAL_ITEM_VIEW_FAIL"});
        console.log(error)
    }
}

export const fetchModalUser = (id, logDetails) => async(dispatch) => {
    dispatch({type: "MODAL_FETCH_USER_START"});
    try {
        const {data} = await UserApi.getUser(id, JSON.stringify(logDetails));
        console.log(data);
        dispatch({type: "MODAL_FETCH_USER_SUCCESS", data: data});
    } catch (error) {
        dispatch({type: "MODAL_FETCH_USER_FAIL"})
        console.log(error);
    }    
}

export const fetchModalItem = (itemId, userId, logDetails) => async(dispatch) => {
    dispatch({type: "MODAL_FETCH_ITEM_START"});
    try {
        const {data} = await ItemApi.getItem(itemId, userId, JSON.stringify(logDetails));
        dispatch({type: "MODAL_FETCH_ITEM_SUCCESS", data: data});
    } catch (error) {
        dispatch({type: "MODAL_FETCH_ITEM_FAIL"})
        console.log(error);
    }    
}

export const closeModalAction = () => async(dispatch) => {
    dispatch({type: "MODAL_CLOSE"})
}

export const modalItemView = (itemId, userId, logDetails) => async (dispatch) => {
    dispatch({type: "MODAL_ITEM_VIEW_START"});
    try {
        console.log("Fetching item...");
        const { data } = await ItemApi.getItem(itemId, userId, JSON.stringify(logDetails))
        console.log("Item fetched successfully:", data?.itemName);
        dispatch({type: "MODAL_ITEM_VIEW_SUCCESS", data: {
            modalType: "referenceItem",
            ...data
        }})
    } catch (error) {
        dispatch({type: "MODAL_ITEM_VIEW_FAIL"})
        console.log(error)
    }
}

export const modalDatumView = (datumId) => async (dispatch) => {
    dispatch({type: "MODAL_ITEM_VIEW_START"});
    try {
        const { data } = await FormApi.getDatumItemById(datumId)
        dispatch({type: "MODAL_ITEM_VIEW_SUCCESS", data: {
            modalType: "referenceDatum",
            ...data[0]
        }})
    } catch (error) {
        dispatch({type: "MODAL_ITEM_VIEW_FAIL"})
        console.log(error)
    }
}